import { FC, useEffect, useState } from 'react';
import { AdminLayout } from '@/components/admin/AdminLayout';
import { LayoutDashboard } from 'lucide-react';
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/components/ui/use-toast";
import { UnifiedAdminDashboard } from '@/components/admin/UnifiedAdminDashboard';

const AdminDashboard: FC = () => {
  const [userEmail, setUserEmail] = useState<string | null>(null);

  useEffect(() => {
    const fetchUserEmail = async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        if (user) {
          console.log('Admin email loaded:', user.email);
          setUserEmail(user.email);
        }
      } catch (error) {
        console.error('Error fetching user email:', error);
        toast({
          variant: "destructive",
          title: "Error",
          description: "No se pudo cargar la información del usuario",
        });
      }
    };

    fetchUserEmail();
  }, []);

  return (
    <AdminLayout>
      <div className="container mx-auto px-4 py-8">
        <div className="flex items-center mb-8">
          <div className="flex items-center gap-3">
            <LayoutDashboard className="w-8 h-8 text-primary" />
            <div>
              <h1 className="text-3xl font-bold text-gray-900">Panel de Administración</h1>
              <p className="text-gray-500 mt-1">
                Administrador: {userEmail || 'Cargando...'}
              </p>
            </div>
          </div>
        </div>

        <UnifiedAdminDashboard />
      </div>
    </AdminLayout>
  );
};

export default AdminDashboard;
